<template>
  <div>
    <el-form-item
      class="custom-label__input width25"
      label="Vai trò"
      prop="flightUserList"
    >
      <div class="flex-row flex__left">
        <el-button class="btnPlain" @click="openAddVbStepInfoDialog">
          <i class="fas fa-plus-circle"></i>
          Chọn cá nhân/đơn vị
        </el-button>
      </div>
    </el-form-item>

    <el-table class="table detailRelatedDocs" :data="vbStepInfoForms">
      <el-table-column width="70" type="index">
        <template #header># </template>
      </el-table-column>

      <el-table-column
        label="Đơn vị"
        show-overflow-tooltip
        property="deptName"
        sortable
      >
      </el-table-column>

      <el-table-column
        v-if="isCxlCaNhan"
        label="Vai trò"
        show-overflow-tooltip
        property="roleName"
        width="100"
        sortable
      >
      </el-table-column>

      <el-table-column
        v-if="isCxlCaNhan"
        label="Tên"
        show-overflow-tooltip
        property="fullName"
        sortable
      >
      </el-table-column>

      <el-table-column
        label="Intrust CA"
        show-overflow-tooltip
        property="fullName"
        align="center"
        width="80"
        v-if="isOutgoingFlow"
      >
        <template slot-scope="{ row }">
          <i
            v-if="row.signIntrustCA"
            :class="[
              'fas fa-check',
              row.signIntrustCA ? 'color__green' : 'color__silver',
            ]"
          ></i>
        </template>
      </el-table-column>


      <el-table-column
        label="Ký token"
        show-overflow-tooltip
        property="fullName"
        align="center"
        width="70"
        v-if="isOutgoingFlow"
      >
        <template slot-scope="{ row }">
          <i
            v-if="row.signToken"
            :class="[
              'fas fa-check',
              row.signToken ? 'color__green' : 'color__silver',
            ]"
          ></i>
        </template>
      </el-table-column>

      <el-table-column
        label="Smart CA"
        show-overflow-tooltip
        property="fullName"
        align="center"
        width="80"
        v-if="isOutgoingFlow"
      >
        <template slot-scope="{ row }">
          <i
            v-if="row.signSmartCA"
            :class="[
              'fas fa-check',
              row.signSmartCA ? 'color__green' : 'color__silver',
            ]"
          ></i>
        </template>
      </el-table-column>

      <el-table-column
        label="Ký sim CA"
        show-overflow-tooltip
        property="fullName"
        align="center"
        width="80"
        v-if="isOutgoingFlow"
      >
        <template slot-scope="{ row }">
          <i
            v-if="row.signType"
            :class="[
              'fas fa-check',
              row.signType ? 'color__green' : 'color__silver',
            ]"
          ></i>
        </template>
      </el-table-column>

      <el-table-column
        label="Trạng thái"
        show-overflow-tooltip
        property="fullName"
        align="center"
        width="80"
      >
        <template slot-scope="{ row }">
          <i
            :class="[
              'fas fa-check',
              row.status === STATUS_.ACTIVE ? 'color__green' : 'color__silver',
            ]"
          ></i>
        </template>
      </el-table-column>

      <el-table-column label="Thao tác" width="100">
        <template slot-scope="{ row }">
          <div>
            <el-button
              size="mini"
              type="primary"
              icon="el-icon-edit"
              circle
              @click="openVbStepInfoFormDialog(row)"
            ></el-button>
            <el-button
              size="mini"
              type="danger"
              icon="el-icon-delete"
              circle
              @click="delete_(row)"
            ></el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <vb-step-info-add-dialog
      v-if="isEnableVbStepInfoAddDialog"
      :isOpen="isOpenVbStepInfoAddDialog"
      :stepType="stepType"
      @dialogClosed="isEnableVbStepInfoAddDialog = false"
      @closeDialog="isOpenVbStepInfoAddDialog = false"
      @submit="addVbStepInfoForms"
      :isOutgoingFlow="isOutgoingFlow"
    />

    <vb-step-info-detail-dialog
      :isOutgoingFlow="isOutgoingFlow"
      v-if="isEnableVbStepInfoDetailDialog"
      :isOpen="isOpenVbStepInfoDetailDialog"
      :vbStepInfoForm="selectedVbStepInfoForm"
      :stepType="stepType"
      @dialogClosed="isEnableVbStepInfoDetailDialog = false"
      @closeDialog="isOpenVbStepInfoDetailDialog = false"
      @submit="updateStepInfoForm"
    />
  </div>
</template>

<script>
import constants from "../../../constants";
import errorMessageFilter from "../../../filters/errorMessageFilter";
// import h from "../../../services/h";
import utils from "../../../services/utils";
import VbStepInfoAddDialog from "./vb-step-info-add-dialog";
import VbStepInfoDetailDialog from "./vb-step-info-detail-dialog";

export default {
  name: "vb-step-info-tables",
  components: { VbStepInfoDetailDialog, VbStepInfoAddDialog },
  props: ["vbStepInfoForms", "context", "stepType", "isOutgoingFlow"],

  data() {
    return {
      selectedVbStepInfoForm: null,
      STATUS_: constants.STATUS_,

      isEnableVbStepInfoAddDialog: false,
      isOpenVbStepInfoAddDialog: false,
      isEnableVbStepInfoDetailDialog: false,
      isOpenVbStepInfoDetailDialog: false,
    };
  },

  computed: {
    isCxlCaNhan() {
      return this.stepType === constants.STEP.STEP_TYPE.CANHAN;
    },
  },

  watch: {
    isOpenVbStepInfoAddDialog(newValue) {
      if (newValue) this.isEnableVbStepInfoAddDialog = true;
    },
    isOpenVbStepInfoDetailDialog(newValue) {
      if (newValue) this.isEnableVbStepInfoDetailDialog = true;
    },
  },

  methods: {
    openAddVbStepInfoDialog() {
      this.isOpenVbStepInfoAddDialog = true;
    },

    updateStepInfoForm({ form }) {
      this.isOpenVbStepInfoDetailDialog = false;
      this.$emit("updateStepInfoForm", {
        vbStepInfoForm: this.selectedVbStepInfoForm,
        form,
      });
    },

    addVbStepInfoForms({ forms }) {
      this.isOpenVbStepInfoAddDialog = false;
      this.$emit("addVbStepInfoForms", { forms });
    },

    delete_(vbStepForms) {
      utils
        .confirm(
          this.$confirm,
          errorMessageFilter({ errorCode: "vbFlow.vbStepInfo.confirm" })
        )
        .then(() => {
          this.$emit("deleteVbStepInfoForm", { form: vbStepForms });
        });
    },

    openVbStepInfoFormDialog(vbStepForm) {
      this.selectedVbStepInfoForm = vbStepForm;
      this.isOpenVbStepInfoDetailDialog = true;
    },

    // isAbleToDelete(vbStepForm) {
    //   //được phép xóa nếu dữ liệu này chưa được insert trong db;
    //   return !h.exists(
    //     this.context.vbStepInfos,
    //     (vbStepInfoForm_) => vbStepInfoForm_.id === vbStepForm.id
    //   );
    // },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/setting/cau-hinh-luong-v2/vb-step-info-tables.vue